import React from "react";
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { AlertCircle, AlertTriangle, Info } from "lucide-react";

const cn = (...inputs) => twMerge(clsx(inputs));

const VARIANTS = {
  danger: {
    box: "border-error-200 bg-error-50 text-error-700 dark:border-rose-800/80 dark:bg-rose-950/40 dark:text-rose-300",
    Icon: AlertCircle,
  },
  warning: {
    box: "border-warning-200 bg-warning-50 text-warning-700 dark:border-amber-800/80 dark:bg-amber-950/40 dark:text-amber-300",
    Icon: AlertTriangle,
  },
  info: {
    box: "border-gray-200 bg-gray-50 text-gray-700 dark:border-gray-700 dark:bg-gray-800/60 dark:text-gray-300",
    Icon: Info,
  },
};

/** Inline status message inside a card or form: title, detail and an optional action. */
const InlineAlert = ({ variant = "info", title, children, action, className }) => {
  const { box, Icon } = VARIANTS[variant] ?? VARIANTS.info;
  return (
    <div role={variant === "danger" ? "alert" : "status"} className={cn("flex items-start gap-2 rounded-lg border p-3 text-xs", box, className)}>
      <Icon size={16} className="mt-0.5 shrink-0" />
      <div className="min-w-0 flex-1">
        {title && <p className="font-semibold">{title}</p>}
        {children && <div className={cn(title && "mt-1")}>{children}</div>}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
};

export default InlineAlert;
